'use client';

import { ErrorBoundary } from 'react-error-boundary';

import dynamic from 'next/dynamic';

import PopularCategoriesRecommendations from './PopulareCategoriesRecommendations';
import CategoriesContainer from './ui/CategoriesContainer';

const PopularCategoriesStatic = dynamic(() => import('./PopularCategoriesStatic'));

const PopularCategories = () => {
  return (
    <CategoriesContainer>
      <ErrorBoundary fallback={<PopularCategoriesStatic />}>
        <PopularCategoriesRecommendations />
      </ErrorBoundary>
    </CategoriesContainer>
  );
};

export default PopularCategories;
